const doneActionsOutput = {
  title: `Completed actions`,
  title1: `Overdue Actions`,
  title2: `Actions to be Done`
};

export default doneActionsOutput;
